import { Text } from '@dixa/lib-shared-habla';

import styles from './knowledgeErrorPlaceholder.module.scss';

type KnowledgeErrorPlaceholderProps = {
  message?: string;
};
export function KnowledgeErrorPlaceholder({
  message,
}: KnowledgeErrorPlaceholderProps): JSX.Element {
  return (
    <Text.Paragraph className={styles.message} variant="4" subdued={true}>
      {message ||
        'Something went wrong, please reload and try again. If this issue persists, please contact support.'}
    </Text.Paragraph>
  );
}
